/* eslint-disable @typescript-eslint/ban-types */
import { TextFieldProps } from '@mui/material';
import React, { ReactNode } from 'react';
import { Control, Controller, Path, RegisterOptions } from 'react-hook-form';
import Input from 'src/components/ui/Input/Input';
import { validateNotWhitespaceOnly } from 'src/utils/formUtils';

interface FormInputProps<T> {
  name: Path<T>;
  control: Control<T, object>;
  type?: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  rules?: RegisterOptions;
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
  helperText?: string;
  error?: boolean;
  required?: boolean;
  inputProps?: TextFieldProps;
  size?: 'small' | 'medium';
}

export const FormInput = <T,>({
  name,
  control,
  type = 'text',
  label,
  placeholder,
  disabled = false,
  className,
  rules,
  startAdornment,
  endAdornment,
  helperText,
  error = false,
  required = false,
  inputProps,
  size,
}: FormInputProps<T>): JSX.Element => (
  <Controller
    name={name}
    control={control}
    rules={{
      ...rules,
      validate: {
        ...rules?.validate,
        ...(rules?.required ? { whitespaces: validateNotWhitespaceOnly } : {}),
      },
    }}
    render={({ field, fieldState }) => (
      <Input
        {...inputProps}
        inputRef={field.ref}
        value={field.value ?? ''}
        onChange={(e) =>
          type === 'number'
            ? field.onChange(parseInt(e.target.value))
            : field.onChange(e.target.value)
        }
        id={name}
        type={type}
        label={label}
        size={size}
        placeholder={placeholder}
        disabled={disabled}
        className={className}
        error={error || !!fieldState?.error?.message}
        required={required}
        helperText={helperText || fieldState?.error?.message}
        InputProps={{ startAdornment, endAdornment }}
      />
    )}
  />
);
